<app-loading-dots></app-loading-dots>

<app-third-party-loader
    *ngIf="metaLiveShoppingScriptUrl"
    [consent]="consent"
    [url]="metaLiveShoppingScriptUrl"
    [scriptOptions]="{
        async: true,
        position: 'beforeBodyEnd',
        attributes: { type: 'module', crossorigin: 'anonymous' }
    }"
></app-third-party-loader>
